import { useEffect, type FC } from 'react'

import { Route, Routes, useLocation } from 'react-router-dom'

import { useCart } from '@/contexts/cart/cart-context'

import { Cart } from './Cart'
import { CartAssets } from './CartAssets'

export const CartRoutes: FC = () => {
  const { pathname } = useLocation()

  const { clearConfirmData } = useCart()

  // Cleanup effect - only on unmount
  useEffect(
    () => () => {
      clearConfirmData()
    },
    [clearConfirmData]
  )

  // Scroll to top on route change within CartRoutes
  useEffect(() => {
    const target = document.getElementById('base-container')
    if (target) {
      target.scrollTo({ top: 0, behavior: 'smooth' })
      return
    }
  }, [pathname])

  return (
    <Routes>
      <Route path="" element={<CartAssets />} />
      <Route path="confirm" element={<Cart />} />
    </Routes>
  )
}
